import { useIntl } from 'react-intl';
import { generatePath } from 'react-router';

import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  BLOG_SPORT,
  BLOG_SPORT_CATEGORY_CATEGORY,
} from '@sorare/core/src/constants/__generated__/routes';

import { categories } from '#src/constants/types.ts';

export const SportTabs = () => (
  <TabBar variant="primary">
    <Tab
      to={generatePath(BLOG_SPORT, {
        sport: 'football',
      })}
      replace={false}
    >
      Football
    </Tab>
    <Tab
      to={generatePath(BLOG_SPORT, {
        sport: 'nba',
      })}
      replace={false}
    >
      NBA
    </Tab>
    <Tab
      to={generatePath(BLOG_SPORT, {
        sport: 'mlb',
      })}
      replace={false}
    >
      MLB
    </Tab>
  </TabBar>
);

export const FootballCategories = ({
  sportCategory,
}: {
  sportCategory: string;
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {Object.entries(categories).map(([key, message]) => (
        <Tab
          key={key}
          to={generatePath(BLOG_SPORT_CATEGORY_CATEGORY, {
            category: key,
            sport: sportCategory.toLowerCase(),
          })}
        >
          {formatMessage(message)}
        </Tab>
      ))}
    </>
  );
};

export const MlbNbaCategories = ({
  sportCategory,
}: {
  sportCategory: string;
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {Object.entries(categories)
        .filter(([key]) => key === 'news')
        .map(([key, message]) => (
          <Tab
            key={key}
            to={generatePath(BLOG_SPORT_CATEGORY_CATEGORY, {
              category: key,
              sport: sportCategory.toLowerCase(),
            })}
          >
            {formatMessage(message)}
          </Tab>
        ))}
    </>
  );
};
